(function($, App, Utils){
  'use strict';

  var logger = new Logger('DataBackground');

  Utils.add('DataBackground', {

    Selector: '*[data-background]',

    bindEvents: function () {
      App.Window
          .off('infinitescroll:newPageLoaded')
          .on('infinitescroll:newPageLoaded', function () {
            Utils.DataBackground.addBackground();
          });
    },

    // seleziono tutti gli elementi e inserisco il bg
    addBackground: function () {
      var $elements = $(Utils.DataBackground.Selector).not('[data-background=""]');
      $.each($elements, function () {
        var $_this = $(this);
        if (!$_this.data('bounded')) {
          $_this.css({
            backgroundImage: $_this.data('background')
          }).data('bounded', true);
        }
      });
    },

    init: function() {
      if (!App.Html.hasClass('objectfit')) {
        this.addBackground();
        this.bindEvents();
      }
    }

  });

})(jQuery, window.App, window.App.Utils);
